import React from 'react';
import Loadable from 'react-loadable';
import Loader from '../../utils/Loader';
import AuthenticatedLayout from '../Layouts/Authenticated';

const DocumentaryCollectionList = Loadable({
    loader: () => import('./list' /* webpackChunkName: "Documentary-collection" */),
    loading() {
        return <Loader />;
    },
});

const ViewDocumentaryCollection = Loadable({
    loader: () => import('./view' /* webpackChunkName: "Documentary-collection" */),
    loading() {
        return <Loader />;
    },
});

const AcceptDocumentaryCollection = Loadable({
    loader: () => import('./accept' /* webpackChunkName: "Documentary-collection" */),
    loading() {
        return <Loader />;
    },
});

export const DocumentaryCollectionComponent = (props: any) => (
    <AuthenticatedLayout>
        <DocumentaryCollectionList {...props} />
    </AuthenticatedLayout>
);

export const ViewDocumentaryCollectionComponent = (props: any) => (
    <AuthenticatedLayout>
        <ViewDocumentaryCollection {...props} />
    </AuthenticatedLayout>
);

export const AcceptDocumentaryCollectionComponent = (props: any) => (
    <AuthenticatedLayout isContentLayout>
        <AcceptDocumentaryCollection {...props} />
    </AuthenticatedLayout>
);
